import { FeatureStateEnum } from '.spec/self-care/tsTypes';
import { useQuery } from '@apollo/client';

import { Feature, FeaturesList } from '@skippay/core/@types/features';

import FeatureFlagsQuery from 'queries/FeatureFlagsQuery.graphql';

type FeatureFlagsQueryType = {
	featureFlags: FeaturesList;
};

export function useFeatureIsEnabled(featureName: Feature): {
	isFeatureEnabled: boolean;
	isLoading: boolean;
} {
	const query = useQuery<FeatureFlagsQueryType>(FeatureFlagsQuery);

	if (query.loading) {
		return {
			isFeatureEnabled: false,
			isLoading: true,
		};
	}

	return {
		isFeatureEnabled: query.data?.featureFlags[featureName] === FeatureStateEnum.ENABLED,
		isLoading: false,
	};
}
